// Tabs der Sonstige-Detailseite (Handoff Sonstige Kontakte §2, Prototyp TB): Kontext-Sidebar und mobiles Segment.
import { LinkSimple, Note, Pulse, SquaresFour, type Icon } from '@phosphor-icons/react';
import { PostLogo } from '../epost/PostLogo';
import type { KontaktTab } from '../../lib/kontakte/detailTab';
import type { KontaktAnzahl } from '../../lib/kontakte/useSonstigerKontakt';

export interface KontaktTabMeta {
  key: KontaktTab;
  label: string;
  icon: Icon;
  /** Index der Avatar-Palette (--sk-av-n) für die aktive Kachel */
  farbe: number;
  tip: string;
  /** Zähler aus der Sidebar-Anzahl (Übersicht ohne) */
  zaehler?: keyof KontaktAnzahl;
}

export const KONTAKT_TAB_META: readonly KontaktTabMeta[] = [
  { key: 'uebersicht', label: 'Übersicht', icon: SquaresFour, farbe: 0, tip: 'Übersicht – Stammdaten und Details' },
  { key: 'verknuepft', label: 'Verknüpft', icon: LinkSimple, farbe: 2, tip: 'Verknüpft – Objekte, Einheiten, Tickets und Dokumente', zaehler: 'verknuepft' },
  { key: 'aktivitaet', label: 'Aktivität', icon: Pulse, farbe: 3, tip: 'Aktivität – Anrufe, Mails, Meetings, Notizen und Änderungen', zaehler: 'aktivitaet' },
  { key: 'notizen', label: 'Notizen', icon: Note, farbe: 4, tip: 'Notizen – Interne Notizen zu diesem Kontakt', zaehler: 'notizen' },
  { key: 'briefe', label: 'Briefe', icon: PostLogo, farbe: 1, tip: 'Briefe – per Post (E-POST) verschickte Briefe und ihr Stand' },
];

/** Zähler-Text: leer bei 0 oder ohne Daten (Prototyp). */
export function tabZaehler(meta: KontaktTabMeta, anzahl: KontaktAnzahl | null): string {
  const n = meta.zaehler && anzahl ? anzahl[meta.zaehler] : 0;
  return n ? String(n) : '';
}
